import React, { useEffect, useState } from 'react'
import styled, { keyframes } from 'styled-components'
import { RCWidth, base, countries, deepClone, generateCircleDot, isValidURL_adv } from '../utils'
import Loading from './Loading'
import { useDispatch, useSelector } from 'react-redux'
import { db } from '../firebase'
import { doc, updateDoc } from 'firebase/firestore'
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';
import { redNex } from '../Redux/nexSlice'
import SentimentVeryDissatisfiedIcon from '@mui/icons-material/SentimentVeryDissatisfied';


function GoogleSearch({ nexListn, _nex }) {
    const [data, setData] = useState([{data: [], siteRank: ''}])
    const [url, setUrl] = useState('')
    const [prevUrl, setPrevUrl] = useState('')
    const [searchTerm, setSearchTerm] = useState('')
    const [location, setLocation] = useState('')

    const [isLoading, setIsLoading] = useState(false)
    const [showInfo, setShowInfo] = useState(false);

    const [noInput1, setNoInput1] = useState(false)
    const [noInput2, setNoInput2] = useState(false)
    const [noInput3, setNoInput3] = useState(false)

    const [noData, setNoData] = useState(false)

    const user = useSelector(state=> state.user.user)
    const nx = useSelector(state=> state.nex.nex)

    const dispatch = useDispatch()

    const getData = async () => {
        if(searchTerm !== '' && location !== '') {
          if(url.trim() !== '') {
            if(isValidURL_adv(url)) {
              setPrevUrl(url)
            } else {
              setNoInput1(true)
              return
            }
          }
          setNoInput1(false)
          setNoInput2(false)
          setNoInput3(false)


          // const updateAnalytics = async ()=> {
          //   const tool = 'google-serp'
          //   let tools = deepClone(user.analytics.toolsUsage)

          //   if(tools['google-search']) {
          //     tools[tool] = tools['google-search']+= 1
          //     delete tools['google-search']
          //   } else {
          //     tools[tool]+= 1
          //   }
            
          //   await updateDoc(doc(db, 'users', user.id), {analytics: {toolsUsage:tools}})
          // }

          const updateAnalytics = async () => {
            const tool = 'google-serp';
            let tools = deepClone(user.analytics.toolsUsage);
        
            // Check if 'google-search' exists
            if (isNaN(tools['google-search']) || tools['google-search'] == 'NaN') {
                // If 'google-search' is NaN or doesn't exist, initialize it
                tools['google-search'] = 1;
            } else {
                // If 'google-search' exists and is valid, increment it
                tools['google-search'] = Number(tools['google-search']) + 1;
            }
        
            // Update 'google-serp' with the incremented 'google-search' value
            tools[tool] = tools['google-search'];
        
            // Remove 'google-search' from the object
            delete tools['google-search'];
        
            // Save the updated tools usage back to Firestore
            await updateDoc(doc(db, 'users', user.id), { analytics: { toolsUsage: tools } });
        };

          setPrevUrl(url)
          setIsLoading(true)
            fetch(`${base}/res`, {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify({
                type: 'gs',
                url: url.trim() === ''? 'example.com': url,
                searchTerm: searchTerm,
                location: location,
                userId: user.id
              })
            }).then(res=> res.json()).then(data=> {
                const sortedData = [...data[0].data].sort((a, b) => {
                    if (a.rank === 'na') return 1;
                    if (b.rank === 'na') return -1;
                    return a.rank - b.rank;
                })
              setData([{
                data: sortedData,
                siteRank: sortedData[0].siteRank
            }])
            setIsLoading(false)
            dispatch(redNex(nx))
            updateAnalytics()
            })
          } else {
            // if(url.trim() === '') setNoInput1(true)
            if(searchTerm.trim() === '') setNoInput2(true)
            if(location.trim() === '') setNoInput3(true)
          }
    }


    const toggleInfo = () => {
      setShowInfo(!showInfo);
  };
  

  useEffect(()=> {
    let timeoutId
    if(isLoading) {
      timeoutId = setTimeout(()=> {
        setIsLoading(false)
        setNoData(true)
      }, 20000)
    }

    return () => clearTimeout(timeoutId)
  }, [isLoading])


  return (
    <GoogleSearchContainer>
        <GoogleSearchInputContainer>
          <div style={{display: 'flex', flexDirection: 'column'}}>
            <h2>Google SERP <span style={{fontSize: 'medium'}}>Organic results only - no ads</span>
            {false && <button onClick={toggleInfo} style={{ marginLeft: '10px', cursor: 'pointer', border: 'none', background: 'none', outline: 'none' }}>
                    {showInfo ? <RemoveIcon style={{color: 'var(--se-color)'}}/> : <AddIcon style={{color: 'var(--se-color)'}}/>}
                </button>}
            </h2>
            {showInfo && (
                <HeaderSpan>
                    <u>One use of this tool</u> is viewing top SERPs for any keyword by location on Google to determine the required domain and page authority to rank.
                </HeaderSpan>
            )}
            </div>
            <GoogleSearchInputInnerContainer>
                <div style={{position: 'relative', marginBottom: '20px'}}><label style={{position: 'absolute', transform: 'translateY(-70%)', left: '23px', top: '20%', fontSize: 'small'}}>Enter URL to see ranking (optional)</label><input type='url' placeholder='example.com' style={{marginLeft: '20px', borderColor: noInput1? 'red': ''}} value={url} onChange={e=> setUrl(e.target.value)}/></div>
                <div style={{position: 'relative', marginBottom: '20px'}}><label style={{position: 'absolute', transform: 'translateY(-70%)', left: '23px', top: '20%', fontSize: 'small'}}>Search Term or Keyword</label><input type='text' placeholder='restaurants near me' style={{marginLeft: '20px', borderColor: noInput2? 'red': ''}} value={searchTerm} onChange={e=> setSearchTerm(e.target.value)}/></div>
                <select name="country" value={location} onChange={e=> setLocation(e.target.value)} className='select-country' style={noInput3? {borderColor: 'red'}: {}}>
                    {countries()}
                </select>
                {nx !== 0 && <button onClick={()=> !isLoading? getData() : ()=> {}} style={isLoading ? {backgroundColor: 'lightgray', color: 'gray', cursor: 'not-allowed'}: {}}>{!isLoading ?'Get Data': 'Getting Data ...'}</button>}
          {nx === 0 && <button style={{backgroundColor: 'lightgray', color: 'red', cursor: 'not-allowed'}}>Insufficient Nexilum units!</button>}
            </GoogleSearchInputInnerContainer>
        </GoogleSearchInputContainer>

        {data[0]?.data.length !== 0 && !isLoading && !noData &&  <GoogleSearchResContainer>
            <GoogleSearchRes>
                        <p style={{width: '20px', fontSize: 'medium', fontFamily: 'Quicksand'}}>Rank</p>
                        <div><div style={{display: 'flex', flexDirection: 'row', alignItems: 'center'}}><span style={{marginLeft: '7px', fontFamily: 'Quicksand'}}>Website</span></div><span style={{color: 'green', fontSize: 'small'}}></span><span style={{color: 'gray', fontSize: 'small'}}></span></div>
                        <p style={{marginLeft: '20px', width: '200px', fontSize: 'medium', fontFamily: 'Quicksand'}}>Page Authority</p>
                        <p style={{marginLeft: '20px', width: '200px', fontSize: 'medium', fontFamily: 'Quicksand'}}>Domain Authority</p>
            </GoogleSearchRes>
            <div style={{overflowX: 'hidden', overflowY: 'scroll'}}>
              {data[0].siteRank && prevUrl.trim() !== '' && <h4 style={{fontWeight: '300', color: 'orangered', backgroundColor: 'rgba(255, 228, 177, 0.358)', width: '500px'}}>{data[0].siteRank}</h4>}
            {data[0]?.data.map(serp=> {
                return (
                    <>
                        <GoogleSearchRes key={serp.rank}>
                        <p style={{width: '20px', fontSize: 'medium'}}>{serp.rank}</p>
                        <div><div style={{display: 'flex', flexDirection: 'row', alignItems: 'center'}}><img src={serp.img} onClick={()=> window.open(serp.url, '_blank')} style={{cursor: 'pointer'}}/><span style={{marginLeft: '7px', color: 'blue', cursor: 'pointer'}} onClick={()=> window.open(serp.url, '_blank')}>{serp.title}</span></div><span style={{color: 'green', fontSize: 'small', cursor: 'pointer', width: 'fit-content'}} onClick={()=> window.open(serp.url, '_blank')}>{serp.url}</span><span style={{color: 'gray', fontSize: 'small'}}>{serp.desc}</span></div>
                        <p style={{marginLeft: '70px', width: '200px', fontSize: 'medium', display: 'flex', flexDirection: 'row', alignItems: 'center', gap: '10px'}}>{serp.pa}</p>
                        <p style={{marginLeft: '30px', width: '200px', fontSize: 'medium', display: 'flex', flexDirection: 'row', alignItems: 'center', gap: '10px'}}>{serp.da}</p>
                        </GoogleSearchRes>
                    </>
                )
            })}
            </div>
        </GoogleSearchResContainer>}
        {isLoading && <Loading />}

        {noData && !isLoading && <GoogleSearchResContainer>
          <p style={{fontFamily: 'Quicksand', fontSize: 'larger', color: 'white', display: 'flex', alignItems: 'center', gap: '10px'}}>
            <SentimentVeryDissatisfiedIcon />
            We couldn't retrieve the data at the moment. Please try again later
          </p>  
        </GoogleSearchResContainer>}

        {data[0].data.length == 0 && !isLoading && <Intro>

          <h3>Tool Overview</h3>
          <br />
          <p>
            The Google SERP Tool allows you to analyze search engine results pages (SERP) for specific keywords. 
            By entering a keyword and location, you can view the current SERP, including top-ranking pages, their metadata, and page authorities on Google.
          </p>
          <br /><br />
          
          <h3>Instructions</h3>
          <br />
          <p>1. Enter a keyword in the search bar</p>
          <p>2. Select your target location</p>
          <p>3. Click "Get Data" to view detailed search engine results and page information</p>
          <br /><br />
          
          <h3>Tips</h3>
          <br />
          <p>Use SERP analysis to understand what content ranks well and identify opportunities to improve your own SEO strategy</p>

      </Intro>}
    </GoogleSearchContainer>
  )
}

export default GoogleSearch


const GoogleSearchContainer = styled.div`
    display: flex;
    flex-direction: column;
    width: ${RCWidth};
`

const GoogleSearchInputContainer = styled.div`
  display: flex;
  flex-direction: column;
  border-radius: 3px;
  box-shadow: 2px 2px 16px -8px rgb(239, 239, 239);
  background-color: white;
  margin-inline: 20px;
  padding: 20px;
  margin-top: 25px;
  z-index: 2;

  > div > h2 {
    font-weight: 100;
    margin-bottom: 20px;
  }

  > div > input {
    outline: none;
    border-radius: 2px;
    width: 200px;
    height: 30px;
    border: 1px solid rgba(235, 235, 235);
    box-shadow: 1px 10px 30px -7px rgba(235, 235, 235);
    padding-inline: 5px;
    margin-block: 10px;
    color: var(--se-color);
  }

  > div > input::placeholder {
    color: rgba(180, 180, 180);
  }

  > div > .select-country {
    outline: none;
    border-radius: 2px;
    width: 200px;
    height: 30px;
    border: 1px solid rgba(235, 235, 235);
    box-shadow: 1px 10px 30px -7px rgba(235, 235, 235);
    padding-inline: 5px;
    margin-block: 10px;
    margin-left: 20px;
    color: var(--se-color);
  }

  > div > button {
    border: none;
    border-radius: 2px;
    height: 30px;
    border: 1px solid rgba(235, 235, 235);
    box-shadow: 1px 10px 30px -7px rgba(235, 235, 235);
    padding-inline: 5px;
    margin-block: 10px;
    padding: 5px;
    margin-left: 60px;
    cursor: pointer;
    background-color: var(--se-color);
    color: white;
  }

  > div > button:hover {
    color: var(--se-color);
    background-color: rgb(239, 239, 239);
  }
`

const fadeInAnimation = keyframes`
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
`


const GoogleSearchInputInnerContainer = styled.div`
  display: flex;
  margin-top: 20px;

  > div > input {
    outline: none;
    border-radius: 2px;
    width: 200px;
    height: 30px;
    border: 1px solid rgba(235, 235, 235);
    box-shadow: 1px 10px 30px -7px rgba(235, 235, 235);
    padding-inline: 5px;
    margin-block: 10px;
    color: var(--se-color);
    padding-left: 100px;
    font-size: medium;
  }

  > div > input::placeholder {
    color: rgba(180, 180, 180);
  }
`

const GoogleSearchResContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 10px;
  margin: 20px;
  overflow-x: hidden;
  overflow-y: hidden;
  background-color: white;
  border-radius: 2px;
  z-index: 2;
  margin-bottom: 70px;
  padding-bottom: 10px;
`


const GoogleSearchRes = styled.div`
    display: flex;
    flex-direction: row;
    padding: 10px;
    margin-block: 5px;
    border-bottom: 1px solid rgb(230, 230, 230);


    > div {
        display: flex;
        flex-direction: column;
        width: 700px;
        margin-left: 30px;
        margin-right: 20px;
    }
`

const HeaderSpan = styled.span`
    font-weight: 300;
    color: var(--se-color);
    font-size: medium;

    opacity: 0;
    animation: ${fadeInAnimation} 0.6s ease-in-out forwards;
`


const Intro = styled.div`
  display: flex;
  flex-direction: column;
  padding: 30px 20px 20px 20px;

  opacity: 0;
  animation: ${fadeInAnimation} 0.3s ease-in-out forwards;

  > h3 {
    color: white;
    font-family: 'Quicksand';
    font-weight: 500;
  }

  > p {
    color: white;
    font-family: 'Quicksand';
    width: 60%;
  }
`